import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Directive({
  selector: '[appAutoFocus]',
})
export class AppAutoFocusDirective implements AfterViewInit {
  @Input()
  shouldAutoFocus = false;
  isBrowser: boolean;

  constructor(
    private elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit(): void {
    if (this.shouldAutoFocus && this.isBrowser) {
      this.elementRef.nativeElement.focus();
    }
  }
}
